/** localStorage: per-user marker of the last client we synced to the backend. */
export const PWA_CLIENT_SYNCED_STORAGE_KEY_PREFIX = 'pwa.client.synced.';

/**
 * Browser tabs: same-client re-sync throttle.
 * Web does not need a fresh "last open" timestamp for admin.
 */
export const PWA_CLIENT_SYNC_THROTTLE_MS = 6 * 60 * 60 * 1000; // 6h

/**
 * Installed PWA: shorter throttle so `last_pwa_open_at` moves when the user
 * comes back to the app. 6h was too long — only logout/login looked "fresh".
 */
export const PWA_CLIENT_PWA_OPEN_THROTTLE_MS = 15 * 60 * 1000; // 15m
